// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion, react-hooks/exhaustive-deps */

import _ from "lodash";
import React, { FC, useEffect, useMemo } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import "../Search/table.css";

type Props = {
	displayItemCount: boolean;
	itemCount?: number | null;
	itemName?: string | null;
	pageNumber: number;
	setPageNumber: React.Dispatch<React.SetStateAction<number>>;
	maxPage: number;
	pageSize: number;
	setPageSize: React.Dispatch<React.SetStateAction<number>>;
	style?: object;
};

const Pagination: FC<Props> = ({
	displayItemCount,
	itemCount,
	itemName,
	pageNumber,
	setPageNumber,
	maxPage,
	pageSize,
	setPageSize,
	style,
}): React.ReactElement => {
	const paginationOptions = [
		{ text: "10", value: 10, key: "10" },
		{ text: "25", value: 25, key: "25" },
		{ text: "50", value: 50, key: "50" },
		{ text: "100", value: 100, key: "100" },
	];

	const pages = useMemo(() => {
		let length = 5;
		let split = 2;

		if (pageNumber - 2 > 1) {
			//showing "1 ..."
			length -= 1;
			split = 1;
		}

		if (pageNumber + 2 < maxPage) {
			//showing "... {maxPage}"
			length -= 1;
		}

		return { length, split };
	}, [maxPage, pageNumber]);

	useEffect(() => {
		if (maxPage < pageNumber) {
			setPageNumber(Math.max(maxPage, 1));
		}
	}, [maxPage]);

	return (
		<div className="pagination" style={style}>
			{displayItemCount && (
				<span>
					{itemCount} {itemName}
					{itemCount !== 1 ? "s" : ""} found
				</span>
			)}
			<Button icon="previous" disabled={pageNumber <= 1} onClick={() => setPageNumber(1)} />
			<Button icon="arrow left" disabled={pageNumber <= 1} onClick={() => setPageNumber((prev) => prev - 1)} />
			<span style={{ fontWeight: 600, userSelect: "none" }}>
				{maxPage > 5 ? (
					<>
						{pageNumber - 2 > 1 && (
							<span key={1}>
								<span className="pageNumber" onClick={() => setPageNumber(1)}>
									1
								</span>
								<span>{" ... "}</span>
							</span>
						)}
						{Array.from(
							{ length: pages.length },
							(_v, k) => _.clamp(pageNumber - pages.split, 1, maxPage - (pages.length - 1))! + k,
						).map((n, i) => (
							<span key={n}>
								<span className={"pageNumber" + (pageNumber === n ? " active" : "")} onClick={() => setPageNumber(n)}>
									{n}
								</span>
								{n !== maxPage && i !== pages.length - 1 && <span style={{ cursor: "default" }}>{", "}</span>}
							</span>
						))}
						{pageNumber + 2 < maxPage && (
							<span key={maxPage}>
								<span>{" ... "}</span>
								<span className="pageNumber" onClick={() => setPageNumber(maxPage)}>
									{maxPage}
								</span>
							</span>
						)}
					</>
				) : (
					<>
						{Array.from({ length: maxPage }, (_v, k) => k + 1).map((n, i) => (
							<span key={n}>
								<span className={"pageNumber" + (pageNumber === n ? " active" : "")} onClick={() => setPageNumber(n)}>
									{n}
								</span>
								{n !== maxPage && i !== maxPage - 1 && <span style={{ cursor: "default" }}>{", "}</span>}
							</span>
						))}
					</>
				)}
			</span>
			<Button icon="arrow right" disabled={pageNumber >= maxPage} onClick={() => setPageNumber((prev) => prev + 1)} />
			<Button icon="next" disabled={pageNumber >= maxPage} onClick={() => setPageNumber(maxPage)} />
			<Dropdown
				selection
				fluid
				className="pageSizeDropdown"
				options={paginationOptions}
				defaultValue={pageSize}
				onChange={(_, { value }) => {
					setPageSize(value as number);
					setPageNumber(1);
				}}
			/>
		</div>
	);
};

export default Pagination;
